import { createSelector } from '@reduxjs/toolkit';

// -------- Overview --------
// This 'slice' is responsible for interactions with connected-react-router

// -------- Selectors --------
const selectPathname = (state) => state.router.location.pathname;

const selectRouterState = (state) => state.router.location.state;

const pathnameSelector = createSelector(selectPathname, (pathname) => pathname);
const hearingIdFromRouterStateSelector = createSelector(
  selectRouterState,
  (state) => state?.hearingId,
);

const stepNumberFromRouterStateSelector = createSelector(
  selectRouterState,
  (state) => state?.stepNumber,
);

// -------- Exporting --------
export {
  pathnameSelector,
  hearingIdFromRouterStateSelector,
  stepNumberFromRouterStateSelector,
};
